export default {
    date: 'تاریخ',
    speciality: 'تخصص',
    name: 'نام پزشک',
    description: 'توضیحات',
}